import type { QueryClient } from '@tanstack/react-query'

// Бэк локализует ответы по ?language=/Accept-Language, а язык не входит в ключи запросов:
// без явной инвалидации адрес площадки, описание олимпиады и прочий локализованный текст
// остаются на прежнем языке до перезагрузки страницы. Реагируем только на фактическую смену:
// старт приложения и повторный выбор того же языка перечитывать не должны.
export function createLanguageChangeInvalidator(client: QueryClient, initialLanguage: string) {
  let current = initialLanguage
  return (lang: string) => {
    if (lang === current) return
    current = lang
    void client.invalidateQueries()
  }
}
